import React, { useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import axios from "axios";
import { FadeLoader } from "react-spinners";
import { useParams } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ProductsByCategory from "../components/ProductsByCategory";

const CategoryCatalogListing = () => {
  const { slug } = useParams(); // Get the category slug from URL
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchCategoryBySlug = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://naqshzari.com/backend/public/api/get-category-by-slug/${slug}`,
        {
          headers: { Accept: "application/json" },
        }
      );
      if (response.data.status === 200) {
        setCategory(response.data.data);
      } else {
        enqueueSnackbar("Category not found", {
          variant: "error",
          autoHideDuration: 2000,
        });
      }
    } catch (error) {
      enqueueSnackbar("Error fetching category", {
        variant: "error",
        autoHideDuration: 2000,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategoryBySlug();
  }, [slug]);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "50vh",
        }}
      >
        <FadeLoader color={"#000000"} loading={loading} width={3} height={10} />
      </div>
    );
  }

  if (!category) {
    return (
      <h3 className="text-center font-weight-bold">
        No category available at the moment.
      </h3>
    );
  }

  return (
    <>
      <Header />
      <div className="catalog-section">
        <div className="catalog-title">{category.title} - Listing</div>
        {category.catalogs && category.catalogs.length > 0 ? (
          <Row>
            {category.catalogs.map((product, index) => (
              <ProductsByCategory key={index} product={product} />
            ))}
          </Row>
        ) : (
          <h3 className="text-center font-weight-bold">
            No catalogs available at the moment.
          </h3>
        )}
      </div>
      <Footer />
    </>
  );
};

export default CategoryCatalogListing;
